import AdminBHULessonProgressCard from './component'
export default AdminBHULessonProgressCard
